import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../@types/filter";
import { Organ } from "../../@types/organ";
import { apisiseci } from "../api";
import { Paginated } from "../../@types/paginated";
import { useDefaultSearchParams } from "../../hooks/useSearchParams";
import { AxiosError } from "axios";

type Props = DefaultFilter;

export function useOrganProfileList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<Organ>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['organProfile', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<Organ>>(
        "/cms/orgaos_perfil/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
